<template>
  <div>
    <div class="mb-3 p-3" style="background-color: #e6f7ff;">
      <h4 class="mx-auto">Faça um upgrade no seu plano e garanta:</h4>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
          <ul class="list-group list-group-flush" v-if="plano.item_planos">
            <li class="list-group-item produtos-plano-lightblue" v-for="item of plano.item_planos" :key="item.id">
              <i class="fa fa-check small" aria-hidden="true"></i>
              <span class="ml-1" v-if="item.quantidade && !item.ilimitado">
                {{item.quantidade}} {{item.nome}}
              </span>
              <span class="ml-1" v-else-if="item.ilimitado">
                {{item.nome}} <span class="text-bold">ilimitados</span>
              </span>
            </li>
          </ul>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
          <div class="row justify-content-end">
            <div class="col-auto">
            <button class="btn btn-customizado btn-customizado-azul" @click="enviarParaCarrinho(plano)">
              Upgrade
            </button>
            </div>
          </div>
          <div class="row justify-content-end mt-1">
            <div class="col-auto">
              <b-link @click="compararPlanos()" class="" style="text-decoration: underline;">Comparar Planos</b-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpgradePlano from './js/upgrade-plano'
export default UpgradePlano
</script>
